import React from 'react';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-center pt-24 pb-16 overflow-hidden" data-id="element-124">
      {/* Decorative elements */}
      <div className="absolute inset-0 overflow-hidden" data-id="element-125">
        <div className="absolute -top-[30%] -right-[10%] w-[70%] h-[70%] rounded-full bg-gradient-to-br from-[#BBDDFF]/20 to-transparent blur-3xl" data-id="element-126"></div>
        <div className="absolute -bottom-[30%] -left-[10%] w-[70%] h-[70%] rounded-full bg-gradient-to-tr from-[#C85A15]/10 to-transparent blur-3xl" data-id="element-127"></div>
      </div>
      <div className="container mx-auto px-6 relative z-10" data-id="element-128">
        <div className="max-w-4xl mx-auto text-center" data-id="element-129">
          <div className="inline-block mb-6 px-4 py-1 rounded-full bg-gradient-to-r from-[#BBDDFF]/20 to-[#C85A15]/20 backdrop-blur-sm border border-white/10" data-id="element-130">
            <span className="text-sm font-medium bg-gradient-to-r from-gray-900 to-gray-700 dark:from-white dark:to-gray-300 bg-clip-text text-transparent" data-id="element-131">
              The future of digital healthcare
            </span>
          </div>
          <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight" data-id="element-132">
            <span className="bg-gradient-to-r from-gray-900 to-gray-700 dark:from-white dark:to-gray-300 bg-clip-text text-transparent" data-id="element-133">
              Better than in-person care,
            </span>
            <br data-id="element-134" />
            <span className="bg-gradient-to-r from-[#BBDDFF] to-[#C85A15] bg-clip-text text-transparent" data-id="element-135">
              from the comfort of home
            </span>
          </h1>
          <p className="text-xl text-gray-600 dark:text-gray-300 mb-10 max-w-2xl mx-auto" data-id="element-136">
            Medications, labs, tracking, and access to a dedicated network of
            providers to make sure your treatments and goals are aligned.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-137">
            <a href="https://staging.joinomu.com/patient/onboarding" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 font-medium py-3 px-8 rounded-full hover:shadow-lg transition-all flex items-center justify-center group" data-id="element-138">
              <span className="bg-gradient-to-r from-gray-900 to-gray-700 dark:from-white dark:to-gray-300 bg-clip-text text-transparent" data-id="element-139">
                Explore Treatments
              </span>
              <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform text-gray-700 dark:text-gray-300" size={18} data-id="element-140" />
            </a>
          </div>
        </div>
        <div className="mt-20 relative" data-id="element-141">
          <div className="relative z-0 bg-gradient-to-br from-[#BBDDFF]/80 to-[#C85A15]/80 rounded-2xl overflow-hidden shadow-2xl backdrop-blur-sm" data-id="element-142">
            <div className="aspect-[16/9] p-1 rounded-2xl" data-id="element-143">
              <div className="w-full h-full rounded-xl overflow-hidden" data-id="element-144">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vaD1D6kVHaykWWJEw1D7AB/Screenshot_2025-10-07_at_6.34.43_PM.png" alt="JoinOmu Health Metrics Dashboard showing weight tracking and medication management" className="w-full h-full object-cover object-top" data-id="element-145" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}